export const productFamilyCodes = {
  BLUE_VOUCHER: 'STAFF',
  BORDER_FORCE: 'Force',
  BSG: 'BSG',
  BSG1: 'BSG1',
  BSG2: 'BSG2',
  BSG3: 'BSG3',
  BSG4: 'BSG4',
  CHARTER_TOLLABLE: 'CTOLL',
  CHARTER: 'CHART',
  CONTRACTOR: 'CONT',
  DUTY_NON_TOLLABLE: 'DUTY',
  DUTY_TOLLABLE: 'DTOLL',
  EDUCATION: 'JOL',
  EUROSTAR_LOYALTY: 'LOYAL',
  ER_STAFF: 'ERSTAFF',
  FIP_E: 'FIP_E',
  FIP_I: 'FIP_I',
  GROUP: 'GROUP',
  INTER_RAIL: 'IRAIL',
  INVITATION: 'INVIT',
  LAST_MINUTE_PUBLIC: 'PUB',
  LAST_MINUTE_RIT: 'RIT',
  MAGICBREAKS_PUBLIC: 'PUB',
  MAGICBREAKS_RIT: 'RIT',
  MICE: 'MICE',
  MOMENTUM: 'MOM',
  OSGRP: 'OSGRP',
  OSRIT: 'OSRIT',
  PALS: 'PALS',
  PARTNER: 'PARTN',
  PUB: 'PUB',
  RAILTEAM_REWARD: 'RTEAM',
  REWARD: 'REWRD',
  RIT: 'RIT',
  SNAP: 'SNAP',
  SNCX: 'SNCX',
  TFL: 'TFL',
  TRIBE: 'TRIBE',
  WALT_DISNEY_PUBLIC: 'PUB',
  WALT_DISNEY_RIT: 'RIT',
  RITPLUS: 'RIT',
  INSTBK_RIT: 'RIT',
  CORPORATE: 'CORP',
  THPASS: 'TH_PASS',
  THPASSFP: 'TH_PASS_FR',
  THPASSPR: 'TH_PASS_PR',
  VIP_RP: 'VIP_RP',
  LOYALTY_COMPANIOIN: 'LOYALCO',
  TEAMGB: 'TEAM_GB',
  TEAMNL: 'TEAM_NL',
  TEAMBE: 'TEAM_BE',
  TEAMDE: 'TEAM_DE',
  PARALYMPIC: 'PARALYMPICS_GB',
  PARALYMPIC_BE: 'PARALYMPICS_BE',
  PARALYMPIC_NL: 'PARALYMPICS_NL',
  MICEGROUP: 'MICE_GROUP',
  RITSP: 'RIT',
  LAST_MINUTE: 'LASTMIN',
  EX_CARRIAGE: 'EX_CARRIAGE',
  RED_US: 'RED_US'
};
